'use client'

import { useEffect, useState } from 'react'

function useOnScreen(ref: any, rootMargin = '0px') {
  // State and setter for storing whether element is visible
  const [isIntersecting, setIntersecting] = useState(false)
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // Update our state when observer callback fires
        setIntersecting(entry.isIntersecting)
      },
      {
        rootMargin,
      },
    )
    if (ref.current) {
      observer.observe(ref.current)
    }
    return () => {
      if (ref.current && observer) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        observer.unobserve(ref?.current)
      }
    }
  }, [ref, rootMargin]) // Empty array ensures that effect is only run on mount and unmount
  return isIntersecting
}

export default useOnScreen
